export default function Telechargement() {
  return (
    <div>
      <h1>Téléchargement</h1>
      <a href="/fiatfichier.pdf" download>Télécharger le fichier PDF</a>
    </div>
  );
}